import React, { useState, useEffect } from "react";
import SocialContainer from "../containers/SocialContainer";
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { exportToExcel, toastError } from "../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import DownloadIcon from "@mui/icons-material/Download";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const DownloadLeads = () => {
  const { id } = useParams();
  const [downloading, setDownloading] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [leadsCount, setLeadsCount] = useState(0);

  const downloadLeads = async () => {
    try {
      setDownloading(true);
      const response = await axios.get(`${API_ENDPOINT}/api/get-leads/${id}`);
      const customerId = response.data.customerId;
      setCustomerId(customerId);
      const list = response.data.leadsList.map((item) => ({
        name: item.name,
        phone: item.phone,
        message: item.message,
        capturedOn:
          new Date(item.capturedOn).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            timeZone: "Asia/Kolkata",
          }) +
          " " +
          new Date(item.capturedOn).toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            timeZone: "Asia/Kolkata",
          }),
      }));
      exportToExcel(list);
      // Show success toast if you have one
      // toastSuccess("Leads downloaded successfully!");
    } catch (error) {
      toastError(error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <SocialContainer>
      <Container maxWidth="md" sx={{ position: "relative", zIndex: 1, py: 4 }}>
        <Paper
          elevation={8}
          sx={{
            p: 6,
            borderRadius: 3,
            background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            textAlign: "center",
          }}
        >
          <Box sx={{ mb: 4 }}>
            <CloudDownloadIcon
              sx={{
                fontSize: 64,
                color: "primary.main",
                mb: 2,
                background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                borderRadius: "50%",
                p: 1.5,
                boxShadow: "0 8px 20px rgba(25, 118, 210, 0.3)",
              }}
            />

            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: 600,
                color: "text.primary",
                mb: 2,
              }}
            >
              Download Your Leads
            </Typography>

            {customerId && (
              <Typography
                variant="h6"
                sx={{
                  color: "text.secondary",
                  mb: 3,
                  fontStyle: "italic",
                }}
              >
                Dear {customerId},
              </Typography>
            )}

            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                lineHeight: 1.6,
                maxWidth: "80%",
                mx: "auto",
                mb: 4,
              }}
            >
              {leadsCount > 0
                ? `You have ${leadsCount} leads ready for download. Click the button below to export them to Excel.`
                : "Your leads are ready for download. Click the button below to export them to Excel format."}
            </Typography>
          </Box>

          <Button
            variant="contained"
            size="large"
            onClick={downloadLeads}
            disabled={downloading}
            startIcon={
              downloading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <DownloadIcon />
              )
            }
            sx={{
              py: 2,
              px: 4,
              fontSize: "1.1rem",
              fontWeight: 600,
              borderRadius: 2,
              background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
              boxShadow: "0 6px 15px rgba(25, 118, 210, 0.4)",
              "&:hover": {
                background: "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)",
                boxShadow: "0 8px 20px rgba(25, 118, 210, 0.6)",
                transform: "translateY(-2px)",
              },
              "&:disabled": {
                background: "grey.300",
                boxShadow: "none",
              },
              transition: "all 0.3s ease",
              minWidth: 200,
            }}
          >
            {downloading ? "Downloading..." : "Download Leads"}
          </Button>

          <Typography
            variant="caption"
            sx={{
              display: "block",
              mt: 3,
              color: "text.secondary",
              fontStyle: "italic",
            }}
          >
            File will be downloaded in Excel format (.xlsx)
          </Typography>
        </Paper>
      </Container>
    </SocialContainer>
  );
};

export default DownloadLeads;
